export const OPEN_DOCTOR_LOCATOR_MODAL = 'OPEN_DOCTOR_LOCATOR_MODAL'
export const CLOSE_DOCTOR_LOCATOR_MODAL = 'CLOSE_DOCTOR_LOCATOR_MODAL'
export const SET_COMPONENT_IS_LOADED_STATUS = 'SET_COMPONENT_IS_LOADED_STATUS'
export const mutations = {
  [OPEN_DOCTOR_LOCATOR_MODAL]: function (state) {
    state.visible = true
  },
  [CLOSE_DOCTOR_LOCATOR_MODAL]: function (state) {
    state.visible = false
  },
  [SET_COMPONENT_IS_LOADED_STATUS]: function (state) {
    state.componentIsLoaded = true
  },
}
